// extracted by mini-css-extract-plugin
export default {"pageNotFound":"NotFound_pageNotFound__atKzk","header":"NotFound_header__uVKl0","linkToHome":"NotFound_linkToHome__OVH4y"};